import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { getAllAlarmTemplatesWithIdProject } from 'services/api';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import Bouton from '../../../UI/Bouton/Bouton';
import DataGrid from '../../../UI/DataGrid/DataGrid';
import styles from './TableauGabarit.module.scss';

// Column factory
const createColumn = (field, labelKey, width, flex) => ({
  field,
  headerName: checkMot(labelKey),
  width,
  ...(width && { minWidth: width }),
  sortable: true,
  align: 'center',
  headerAlign: 'center',
  ...(flex && { flex }),
});

// Column configuration [field, labelKey, width, flex]
const COLUMN_CONFIG = [
  ['template_id', 'template_id', 100, null],
  ['project_id', 'project_id', 100, null],
  ['template_name', 'template_name', 150, 1],
  ['start', 'start', 100, null],
  ['end', 'end', 100, null],
  ['private', 'private', 50, null],
  ['alarm_level', 'alarm_level', 50, null],
];

const TableauGabarit = (props) => {
  const [templateList, setTemplateList] = useState([]);
  const [selectionModel, setSelectionModel] = useState([]);

  const getTemplates = useCallback(async () => {
    try {
      const response = await getAllAlarmTemplatesWithIdProject({
        list_project_id: props.filtre_projects_list_id,
      });
      if (response.data.state) {
        setTemplateList(response.data.list_templates);
      }
    } catch (error) {
      console.error('Error fetching templates:', error);
    }
  }, [props.filtre_projects_list_id]);

  useEffect(() => {
    getTemplates();
  }, [getTemplates]);

  const columns = useMemo(
    () =>
      COLUMN_CONFIG.map(([field, labelKey, width, flex]) =>
        createColumn(field, labelKey, width, flex)
      ),
    []
  );

  const handleSelectionModelChange = useCallback(
    (newSelection) => {
      if (!newSelection?.length) return;
      const first = newSelection[0];
      setSelectionModel([first]);
      const selectedRow = templateList?.find(
        (row) => row.template_id === first
      );
      if (selectedRow) {
        props.selectioneLigne(selectedRow);
      }
    },
    [templateList, props]
  );

  const handleRadioSelect = useCallback(
    (row) => {
      setSelectionModel([row.template_id]);
      props.selectioneLigne(row);
    },
    [props]
  );

  const radioColumn = useMemo(
    () => ({
      field: '__select__',
      headerName: '',
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <input
          type="radio"
          checked={selectionModel[0] === params.row.template_id}
          onChange={() => handleRadioSelect(params.row)}
        />
      ),
    }),
    [handleRadioSelect, selectionModel]
  );

  const mergedColumns = useMemo(
    () => [radioColumn, ...columns],
    [radioColumn, columns]
  );

  if (!templateList || templateList.length === 0) {
    return (
      <Bouton cliquer={() => getTemplates(props.filtre_projects_list_id)}>
        {checkMot('refresh')}
      </Bouton>
    );
  }

  return (
    <div className={styles.container}>
      <DataGrid
        rows={templateList}
        columns={mergedColumns}
        getRowId={(row) => row.template_id}
        rowSelectionModel={selectionModel}
        onRowSelectionModelChange={(newSelection) =>
          handleSelectionModelChange(newSelection)
        }
        pageSizeOptions={[25, 50, 100]}
        initialPageSize={25}
        autoRowHeight
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    filtre_projects_list_id: state.authentifie.filtre_projects_list_id,
  };
};

export default connect(mapStateToProps)(TableauGabarit);
